export default "__VITE_ASSET__ccea8504__"